import { FileObjectType } from "@jsq/ds/core";

/**
 * Checks if a document has unsaved changes by comparing the initial file with the current file.
 *
 * A document is considered to have unsaved changes if:
 * - A new file was uploaded (currentFile exists with lastModified property and no initialFile)
 * - An existing file was removed (initialFile exists but currentFile is null)
 * - An existing file was replaced (both files exist but have different UUIDs)
 *
 * @param initialFile - The original file when the component was loaded
 * @param currentFile - The current file in the component state
 * @returns true if there are unsaved changes, false otherwise
 */
export const hasUnsavedDocumentChanges = (
  initialFile: FileObjectType | null,
  currentFile: FileObjectType | null,
): boolean => {
  if (!initialFile && !currentFile) {
    return false;
  }

  if (initialFile && !currentFile) {
    return true;
  }

  if (!initialFile && currentFile && !!currentFile.file?.lastModified) {
    return true;
  }

  if (
    initialFile &&
    currentFile &&
    !!currentFile.file?.lastModified &&
    initialFile.uuid !== currentFile.uuid
  ) {
    return true;
  }

  return false;
};
